module.exports = __webpack_public_path__ + "img/unauthorized.40b450ee.png";